import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { getLogoutTargetUrl } from 'helper/auth-helper';
import { isAuthHintEmpty } from './session-helper';

export const AuthComponentHOC = (
  Component,
  authRequired = true,
  renderCondition,
) => {
  const NewComponent = props => {
    const ConditionedRenderComponent = useMemo(
      () => {
        // eslint-disable-next-line react/prop-types
        const ConditionedRenderComponent = ({ shouldRender, ...rest }) =>
          shouldRender ? <Component {...rest} /> : null;
        return connect(state => ({
          shouldRender: renderCondition(state),
        }))(ConditionedRenderComponent);
      },
      [renderCondition, Component],
    );

    if (authRequired && isAuthHintEmpty()) {
      window.location.replace(getLogoutTargetUrl());
      return null;
    }

    if (!renderCondition) return <Component {...props} />;

    return <ConditionedRenderComponent {...props} />;
  };
  NewComponent.displayName = Component.displayName;
  return NewComponent;
};

export default AuthComponentHOC;
